import React, { useEffect } from "react";
import { inject, observer } from 'mobx-react';
import MaterialTable from "material-table";
import { userColumns,  TableOptions, localization } from '../Constants';
import { RenderIntersectionTable } from "../HelperFunctionsReporting"
import { LoadingSpinner } from '../../LoadingSpinner/LoadingSpinner';
import ReportsMenu from '../ReportsMenu';
import Legend from './Legend';
import '../Reporting.css';

const IntersectionTable = inject('RootStore')(observer(({ RootStore }) => {
  useEffect((() => {
    RootStore.reportingStore.setRenderSpinner(true)
    RootStore.reportingStore.getAllReports()
  }), [RootStore.reportingStore]);

  return (
    <div className="row">
      {RootStore.reportingStore.renderSpinner && <LoadingSpinner text='Loading reports' />}
      <ReportsMenu />
      <div className="col-sm-8" id="report-table">
        <div>
          {<MaterialTable
            title="Intersection Report"
            data={RootStore.reportingStore.allReports}
            columns={userColumns}
            options={TableOptions}
            localization={localization}
            onRowClick={(event, rowData, togglePanel) => togglePanel()}
            detailPanel={[
              {
                tooltip: 'Show PG',
                render: rowData => RenderIntersectionTable(rowData),
              },
            ]}
          />}
        </div>
      </div>
      <Legend />
    </div>
  )
}));

export default IntersectionTable;
